import { TabletTab } from 'components/molecules/TabletTab';
import CompressionRegistration from 'components/organisms/CompressionRegistration';
import ProcessingListContent from 'components/organisms/ProcessingListContent/ProcessingListContent';
import { PrimaryTemplate } from 'components/templates/PrimaryTemplate';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';
import { ProcessingMode } from 'util/Enums';

const ProcessingRegistration = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const user = useSelector(selectUser);
  const [isRefresh, setRefresh] = useState(false);

  const isAuto = user.processingMode === ProcessingMode.Auto;

  return (
    <PrimaryTemplate h1={t('nav.processing_registration')}>
      {isAuto ? (
        <CompressionRegistration
          isRefresh={isRefresh}
          setRefresh={setRefresh}
        />
      ) : (
        <TabletTab
          tabItems={[
            t('processing_registration.title'),
            t('processing_registration.in_process_materials'),
          ]}
          defaultTabIndex={history.location.hash === '#1' ? 1 : 0}
          renderContent={({ index }) => {
            if (index === 0) {
              return (
                <CompressionRegistration
                  isRefresh={isRefresh}
                  setRefresh={setRefresh}
                />
              );
            }

            return <ProcessingListContent />;
          }}
        />
      )}
    </PrimaryTemplate>
  );
};

export default ProcessingRegistration;
